import DsWidgetItem from "./DsWidgetItem";
export default DsWidgetItem;
